module.exports = __webpack_public_path__ + "img/8.009ca6f5.webp";